import { MutationTree } from 'vuex';
import { FlowDesignerState } from '.';
import {
	SET_CURRENT_FLOW,
	ADD_FLOW_VARIABLE,
	SET_FLOW_NAME,
	MAKE_DIRTY,
	RESET_CHANGE_TRACKER,
	SET_IS_SAVE_FLOW_IN_PROGRESS,
	SET_FLOWS,
	SET_FLOW_VARIABLES,
	SET_FLOW_STATUS,
	UPDATE_FLOW,
	CLEAR_FLOWS_CACHE,
} from './mutationTypes';
import {
	InputVariableViewModel,
	FlowViewModel,
	ChangeType
} from '@/features/bots/models/designer';
import {FlowListItemViewModel} from '@/features/bots/models/flowListItemViewModel';
import { FlowStatus } from '@/features/bots/models/flowStatus';

export const mutations: MutationTree<FlowDesignerState> = {

	[SET_CURRENT_FLOW](state, flow: FlowViewModel) {
		state.currentFlow = {
			id: flow.id,
			name: flow.name,
			status: flow.status,
			businessHours: flow.businessHours || [],
			paths: flow.paths || [],
			triggers: flow.triggers || [],
			parentFlows: flow.parentFlows,
			parentAnswers: flow.parentAnswers,
			scheduleCondition: flow.scheduleCondition && flow.scheduleCondition.attribute !== null ? flow.scheduleCondition : undefined,
			triggerConditions: flow.triggerConditions || {
				type: 'and',
				conditions: []
			},
			audienceConditions: flow.audienceConditions || {
				type: 'and',
				conditions: []
			},
			targetContactTypes: flow.targetContactTypes || []
		};
	},

	[SET_FLOW_VARIABLES](state, flowVariables: InputVariableViewModel[]) {
		state.flowVariables = flowVariables;
	},

	[ADD_FLOW_VARIABLE](state, flowVar: InputVariableViewModel) {
		state.flowVariables.push(flowVar);
	},

	[SET_FLOW_NAME](state, flowName: string) {
		state.currentFlow.name = flowName;
	},

	[MAKE_DIRTY](state, key: ChangeType) {
		state.changes[key] = true;
	},

	[SET_FLOW_STATUS](state, flowStatus: FlowStatus) {
		state.currentFlow.status = flowStatus;
		const flow = state.flows.find(f => f.id === state.currentFlow.id);
		if (flow) {
			flow.status = flowStatus;
		}
	},

	[RESET_CHANGE_TRACKER](state) {
		state.changes = {
			[ChangeType.Name]: false,
			[ChangeType.Paths]: false,
			[ChangeType.Triggers]: false,
			[ChangeType.Conditions]: false
		};
	},

	[SET_IS_SAVE_FLOW_IN_PROGRESS](state, isSaving: boolean) {
		state.isSaveFlowInProgress = isSaving;
	},

	[SET_FLOWS](state, flows: FlowListItemViewModel[]) {
		state.flows = flows;
	},

	[UPDATE_FLOW](state, flow: FlowViewModel) {
		state.flows = state.flows.map(f => {
			if (f.id === flow.id) {
				return {
					...f,
					name: flow.name,
					status: flow.status,
					triggers: flow.triggers,
				};
			}
			return f;
		});
	},

	[CLEAR_FLOWS_CACHE](state) {
		state.flows = [];
	}
};
